import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { getEmpresaAtual } from './api';
import {
  coresHex, hexParaRgb, escurecer, clarear,
} from '../styles/styleUtils';

// Converte um hex de coresHex em rgb() 0-1 do pdf-lib (que não entende var()/hex).
const rgbHex = (hex) => {
  const { r, g, b } = hexParaRgb(hex);
  return rgb(r / 255, g / 255, b / 255);
};

// ── Pizza via Canvas (alta resolução) ────────────────────────────────────
const gerarPizzaCanvas = (dados, cores) => new Promise((resolve) => {
  const SCALE = 3;
  const size  = 300 * SCALE;
  const canvas = document.createElement('canvas');
  canvas.width = size; canvas.height = size;
  const ctx = canvas.getContext('2d');
  const cx = size/2; const cy = size/2; const r = size*0.38;
  const total = dados.reduce((s,d)=>s+d.value,0);
  let startAngle = -Math.PI/2;
  dados.forEach((d,i) => {
    const slice = total>0?(d.value/total)*2*Math.PI:0;
    ctx.beginPath(); ctx.moveTo(cx,cy);
    ctx.arc(cx,cy,r,startAngle,startAngle+slice); ctx.closePath();
    ctx.fillStyle=cores[i%cores.length]; ctx.fill();
    ctx.strokeStyle='#fff'; ctx.lineWidth=4; ctx.stroke();
    if(slice>0.25){
      const mid=startAngle+slice/2;
      const pct=((d.value/total)*100).toFixed(1);
      ctx.fillStyle='#fff'; ctx.font=`bold ${32}px Arial`;
      ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillText(`${pct}%`, cx+Math.cos(mid)*r*0.65, cy+Math.sin(mid)*r*0.65);
    }
    startAngle+=slice;
  });
  resolve(canvas.toDataURL('image/png'));
});

const generatePdfRelatorioVendasServico = async (data, filtro) => {
  if (!data) return;

  const pdfDoc  = await PDFDocument.create();
  const fontReg = await pdfDoc.embedFont(StandardFonts.Helvetica);
  const fontBold= await pdfDoc.embedFont(StandardFonts.HelveticaBold);

  const W=595.28; const H=841.89;
  const ML=40; const MR=40;
  const CW=W-ML-MR;

  const C = {
    cinzaChumbo: rgbHex(coresHex.chumbo),
    cinzaMedio:  rgbHex(coresHex.cinzaMedio),
    cinzaClaro:  rgbHex(coresHex.cinzaClaro),
    laranja:     rgbHex(coresHex.laranja),
    laranjaClaro:rgbHex(coresHex.laranjaClaro),
    laranjaEsc:  rgbHex(coresHex.laranjaEscuro),
    branco:      rgb(1,1,1),
    preto:       rgb(0.133,0.133,0.133),
    borda:       rgbHex(coresHex.borda),
  };

      const CORES_HEX = [
    coresHex.laranja,
    coresHex.chumbo,
    escurecer(coresHex.laranja, 0.30),
    coresHex.cinzaMedio,
    escurecer(coresHex.laranja, 0.60),
    clarear(coresHex.chumbo, 0.45),
    escurecer(coresHex.laranja, 0.80),
    clarear(coresHex.cinzaMedio, 0.20),
  ];
  const CORES_RGB = CORES_HEX.map(rgbHex);

  const fmtBRL = (v) => parseFloat(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});

  const drawRect  = (pg,x,y,w,h,color) => pg.drawRectangle({x,y,width:w,height:h,color});
  const drawBRect = (pg,x,y,w,h,fill,border) => pg.drawRectangle({x,y,width:w,height:h,color:fill,borderColor:border||C.borda,borderWidth:0.5});
  const drawText  = (pg,t,x,y,s,f,color) => pg.drawText(String(t??''),{x,y,size:s,font:f,color});
  const drawLine  = (pg,x1,y1,x2,y2,color=C.borda,t=0.5) => pg.drawLine({start:{x:x1,y:y1},end:{x:x2,y:y2},thickness:t,color});

  const tH=14;
  const drawRow=(pg,cells,y)=>{
    cells.forEach((c)=>{
      drawBRect(pg,c.x,y-tH+2,c.w,tH,c.fill,c.bc||C.borda);
      if(c.text!=null&&c.text!==''){
        const sz=c.sz||8; const fn=c.fn||fontReg;
        let tx=c.x+3;
        if(c.al==='r') tx=c.x+c.w-fn.widthOfTextAtSize(String(c.text),sz)-3;
        if(c.al==='c') tx=c.x+(c.w-fn.widthOfTextAtSize(String(c.text),sz))/2;
        drawText(pg,c.text,tx,y-tH+5,sz,fn,c.cl||C.preto);
      }
    });
    return y-tH;
  };

  // ── Logo ──────────────────────────────────────────────────────────────────
  let logoImage = null;
  let empresa = null;
  try {
    empresa = await getEmpresaAtual();
    if (empresa?.logoBranca) {
      const base64 = empresa.logoBranca.split(',')[1];
      const bin = atob(base64);
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i += 1) bytes[i] = bin.charCodeAt(i);
      logoImage = await pdfDoc.embedPng(bytes);
    }
  } catch (e) { /* sem logo */ }

  const usuarioLogado=JSON.parse(localStorage.getItem('userData')||'{}');
  const solicitante=usuarioLogado?.nome||'—';

  const periodo=[
    filtro?.datainicial?new Date(filtro.datainicial).toLocaleDateString('pt-BR'):'',
    filtro?.datafinal?new Date(filtro.datafinal).toLocaleDateString('pt-BR'):'',
  ].filter(Boolean).join(' até ');

  const TITULO = 'Relatório de Vendas de Serviço';
  const drawHeader=(pg,titulo)=>{
    drawRect(pg,0,H-44,W,44,C.cinzaChumbo);
    drawRect(pg,0,H-44,6,44,C.laranja);
    if(logoImage){const d=logoImage.scaleToFit(70,28);pg.drawImage(logoImage,{x:ML,y:H-39,width:d.width,height:d.height});}
    else{drawText(pg, empresa?.nome || 'Marcki Engenharia', ML, H - 26, 11, fontBold, C.branco);}
    drawText(pg,titulo,W-MR-fontBold.widthOfTextAtSize(titulo,10),H-24,10,fontBold,C.branco);
    if(periodo) drawText(pg,`Período: ${periodo}`,W-MR-fontReg.widthOfTextAtSize(`Período: ${periodo}`,8),H-36,8,fontReg,rgb(0.8,0.8,0.8));
    return H-58;
  };

  const drawFooter=(pg)=>{
    drawRect(pg,0,0,W,26,C.cinzaChumbo);
    drawRect(pg,0,0,6,26,C.laranja);
    drawText(pg,`Solicitante: ${solicitante}`,ML+8,9,7,fontReg,rgb(0.8,0.8,0.8));
    drawText(pg,`Gerado em ${new Date().toLocaleDateString('pt-BR')}`,W-MR-70,9,7,fontReg,rgb(0.8,0.8,0.8));
  };

  const r   = data.secao2_resumo||{};
  const s4  = data.secao4_segmentacoes||{};
  const vendas = data.secao1_vendasRealizadas||[];

  // ── Barras verticais (alta resolução) ─────────────────────────────────────
  const gerarBarrasVertCanvas = (dados, cores, dispW, dispH) => new Promise((resolve2) => {
    const SCALE=3;
    const cW2=Math.round(dispW*SCALE);
    const cH2=Math.round(dispH*SCALE);
    const cv=document.createElement('canvas');
    cv.width=cW2; cv.height=cH2;
    const ctx2=cv.getContext('2d');

    const padX  = 10*SCALE;
    const padTop= 18*SCALE;
    const padBot= 34*SCALE;
    const baseY = cH2-padBot;
    const topY  = padTop;
    const chartH= baseY-topY;

    const maxV=Math.max(...dados.map(d=>d.value),1);
    const n=dados.length;
    const slot=(cW2-padX*2)/n;
    const barW2=Math.min(slot*0.55,70*SCALE);

    ctx2.fillStyle='#F5F5F5'; ctx2.fillRect(0,0,cW2,cH2);
    for(let g=0;g<=4;g+=1){
      const gy=baseY-(g/4)*chartH;
      ctx2.strokeStyle='#DDD'; ctx2.lineWidth=1*SCALE;
      ctx2.beginPath(); ctx2.moveTo(padX,gy); ctx2.lineTo(cW2-padX,gy); ctx2.stroke();
    }

    const quebraRotulo = (texto, maxW) => {
      const palavras=String(texto).split(' ');
      const linhas=[]; let atual='';
      palavras.forEach(p=>{
        const teste=atual?`${atual} ${p}`:p;
        if(ctx2.measureText(teste).width<=maxW||!atual){ atual=teste; }
        else { linhas.push(atual); atual=p; }
      });
      if(atual) linhas.push(atual);
      const out=linhas.slice(0,2);
      if(linhas.length>2){
        let ult=out[1];
        while(ult.length>0&&ctx2.measureText(`${ult}...`).width>maxW){ ult=ult.slice(0,-1); }
        out[1]=`${ult}...`;
      }
      return out.map(ln=>{
        if(ctx2.measureText(ln).width<=maxW) return ln;
        let s=ln;
        while(s.length>0&&ctx2.measureText(`${s}...`).width>maxW){ s=s.slice(0,-1); }
        return `${s}...`;
      });
    };

    ctx2.textAlign='center';
    dados.forEach((d,i)=>{
      const barH=(d.value/maxV)*chartH;
      const x2=padX+i*slot+(slot-barW2)/2;
      const rad=Math.max(0,Math.min(4*SCALE,barW2/2,barH/2));
      ctx2.fillStyle=cores[i%cores.length];
      ctx2.beginPath(); ctx2.roundRect(x2,baseY-barH,barW2,barH,rad); ctx2.fill();
      ctx2.fillStyle='#333'; ctx2.font=`bold ${13*SCALE}px Arial`;
      ctx2.fillText(String(d.value),x2+barW2/2,baseY-barH-5*SCALE);
      ctx2.font=`${11*SCALE}px Arial`; ctx2.fillStyle='#555';
      const linhaH=13*SCALE;
      const linhas=quebraRotulo(d.name,slot-6*SCALE);
      linhas.forEach((ln,li)=>{
        ctx2.fillText(ln,x2+barW2/2,baseY+14*SCALE+li*linhaH);
      });
    });
    resolve2(cv.toDataURL('image/png'));
  });

  // Barras — Tipo de Serviço (no lugar de Forma de Pagamento na PG1 topo)
  const dadosTipoServicoBarra=(s4.porTipoServico||[]).map(d=>({name:d.grupo,value:d.numeroVendas})).filter(d=>d.value>0);
  let barrasTipoServicoImg=null;
  if(dadosTipoServicoBarra.length>0){
    const url=await gerarBarrasVertCanvas(dadosTipoServicoBarra,CORES_HEX,CW,100);
    const bytes=await fetch(url).then(resp=>resp.arrayBuffer());
    barrasTipoServicoImg=await pdfDoc.embedPng(bytes);
  }

  // ── Pizzas — Forma Pagamento e Forma Atendimento ───────────────────────────
  const dadosPag = (s4.porFormaPagamento||[]).map(d=>({name:d.grupo,value:d.numeroVendas})).filter(d=>d.value>0);
  const dadosAte = (s4.porFormaAtendimento||[]).map(d=>({name:d.grupo,value:d.numeroVendas})).filter(d=>d.value>0);

  let pizzaPagImg=null; let pizzaAteImg=null;
  if(dadosPag.length>0){const url=await gerarPizzaCanvas(dadosPag,CORES_HEX);const b=await fetch(url).then(r=>r.arrayBuffer());pizzaPagImg=await pdfDoc.embedPng(b);}
  if(dadosAte.length>0){const url=await gerarPizzaCanvas(dadosAte,CORES_HEX);const b=await fetch(url).then(r=>r.arrayBuffer());pizzaAteImg=await pdfDoc.embedPng(b);}

  // ============================================================
  // PG 1 — KPIs + GRÁFICOS (sem Meta — nao esta no escopo aprovado p/ servico)
  // ============================================================
  const p1=pdfDoc.addPage([W,H]);
  let y1=drawHeader(p1,TITULO);
  y1-=10;

  if(periodo){drawText(p1,`De ${periodo}`,ML,y1,8,fontReg,C.cinzaMedio);y1-=14;}
  if(filtro?.servico){drawText(p1,`Serviço: ${filtro.servico}`,ML,y1,8,fontReg,C.laranja);y1-=14;}

  // KPIs (sem potencia/kWp/valorPorKwp)
  const kpiW=(CW-15)/4; const kpiH=36;
  const kpis=[
    {label:'Total Vendido',        valor:fmtBRL(r.totalVendido)},
    {label:'Quantidade de Vendas', valor:String(r.qtdVendas||0)},
    {label:'Ticket Médio (R$)',    valor:fmtBRL(r.ticketMedioReais)},
    {label:'Taxa de Conversão',    valor:`${Number(r.taxaConversao||0).toFixed(2)}%`},
  ];
  kpis.forEach((kpi,i)=>{
    const x=ML+i*(kpiW+5);
    drawBRect(p1,x,y1-kpiH,kpiW,kpiH,C.laranjaClaro,C.laranja);
    drawRect(p1,x,y1-kpiH,3,kpiH,C.laranja);
    drawText(p1,kpi.label,x+6,y1-13,7,fontReg,C.cinzaMedio);
    drawText(p1,kpi.valor,x+6,y1-28,10,fontBold,C.cinzaChumbo);
  });
  y1-=kpiH+16;

  // Pizzas lado a lado — Forma Pagamento / Forma Atendimento
  const pizzaSize=120;
  const pizzaY=y1-pizzaSize-10;
  if(pizzaPagImg){
    drawText(p1,'Forma de Pagamento',ML+10,y1-4,8,fontBold,C.preto);
    p1.drawImage(pizzaPagImg,{x:ML,y:pizzaY,width:pizzaSize,height:pizzaSize});
    let legY=y1-12;
    dadosPag.forEach((d,i)=>{
      const tot=dadosPag.reduce((s,x)=>s+x.value,0);
      const pct=tot>0?((d.value/tot)*100).toFixed(1):'0';
      drawRect(p1,ML+pizzaSize+8,legY-7,8,8,CORES_RGB[i%CORES_RGB.length]);
      const label=d.name.length>18?`${d.name.substring(0,18)}...`:d.name;
      drawText(p1,`${label}: ${pct}%`,ML+pizzaSize+20,legY-5,6,fontReg,C.preto);
      legY-=11;
    });
  }
  if(pizzaAteImg){
    const x2=ML+CW/2+10;
    drawText(p1,'Forma de Atendimento',x2,y1-4,8,fontBold,C.preto);
    p1.drawImage(pizzaAteImg,{x:x2,y:pizzaY,width:pizzaSize,height:pizzaSize});
    let legY=y1-12;
    dadosAte.forEach((d,i)=>{
      const tot=dadosAte.reduce((s,x)=>s+x.value,0);
      const pct=tot>0?((d.value/tot)*100).toFixed(1):'0';
      drawRect(p1,x2+pizzaSize+8,legY-7,8,8,CORES_RGB[i%CORES_RGB.length]);
      const label=d.name.length>16?`${d.name.substring(0,16)}...`:d.name;
      drawText(p1,`${label}: ${pct}%`,x2+pizzaSize+20,legY-5,6,fontReg,C.preto);
      legY-=11;
    });
  }
  y1=pizzaY-20;

  // Gráfico de barras verticais — Tipo de Serviço
  if(barrasTipoServicoImg){
    drawText(p1,'Vendas por Tipo de Serviço',ML,y1,8,fontBold,C.preto);
    y1-=8;
    p1.drawImage(barrasTipoServicoImg,{x:ML,y:y1-100,width:CW,height:100});
    y1-=110;
  }

  drawFooter(p1);

  // ============================================================
  // PG 2 — TABELA DE VENDAS
  // ============================================================
  const p2=pdfDoc.addPage([W,H]);
  let y2=drawHeader(p2,TITULO);
  y2-=16;

  drawRect(p2,ML,y2+2,CW,16,C.cinzaChumbo);
  drawText(p2,'VENDAS DE SERVIÇO REALIZADAS',ML+6,y2+7,8,fontBold,C.branco);
  y2-=16;

  const c1=CW*0.20;const c2=CW*0.10;const c3=CW*0.14;
  const c4=CW*0.19;const c5=CW*0.19;const c6=CW-c1-c2-c3-c4-c5;

  y2=drawRow(p2,[
    {x:ML,                w:c1,fill:C.laranja,text:'Cliente',       fn:fontBold,cl:C.branco},
    {x:ML+c1,             w:c2,fill:C.laranja,text:'Data',          fn:fontBold,cl:C.branco},
    {x:ML+c1+c2,          w:c3,fill:C.laranja,text:'Valor',         fn:fontBold,cl:C.branco,al:'r'},
    {x:ML+c1+c2+c3,       w:c4,fill:C.laranja,text:'Vend. Aber.',   fn:fontBold,cl:C.branco},
    {x:ML+c1+c2+c3+c4,    w:c5,fill:C.laranja,text:'Vend. Fecha.',  fn:fontBold,cl:C.branco},
    {x:ML+c1+c2+c3+c4+c5, w:c6,fill:C.laranja,text:'Pagamento',     fn:fontBold,cl:C.branco},
  ],y2);

  vendas.forEach((v,i)=>{
    if(y2<50) return;
    const fill=i%2===0?C.cinzaClaro:C.branco;
    y2=drawRow(p2,[
      {x:ML,                w:c1,fill,text:(v.cliente||'').substring(0,22)},
      {x:ML+c1,             w:c2,fill,text:v.data},
      {x:ML+c1+c2,          w:c3,fill,text:fmtBRL(v.valor),al:'r'},
      {x:ML+c1+c2+c3,       w:c4,fill,text:(v.vendedorAbertura||'').substring(0,20)},
      {x:ML+c1+c2+c3+c4,    w:c5,fill,text:(v.vendedorFechamento||'').substring(0,20)},
      {x:ML+c1+c2+c3+c4+c5, w:c6,fill,text:(v.formaPagamento||'').substring(0,16)},
    ],y2);
  });

  // Totalizador
  y2-=6;
  drawBRect(p2,ML,y2-tH+2,CW,tH,C.laranjaClaro,C.laranja);
  drawText(p2,`Total: ${vendas.length} vendas`,ML+4,y2-tH+5,8,fontBold,C.laranjaEsc);
  drawText(p2,`Total Vendido: ${fmtBRL(r.totalVendido)}`,ML+c1+c2+c3-4,y2-tH+5,8,fontBold,C.laranjaEsc);

  // Resumo de orçamentos
  if(data.secao3_orcamentos){
    y2-=20;
    drawRect(p2,ML,y2+2,CW,16,C.cinzaChumbo);
    drawText(p2,'RESUMO DE ORÇAMENTOS POR ORIGEM',ML+6,y2+7,8,fontBold,C.branco);
    y2-=16;
    const oc1=CW*0.30;const oc2=CW*0.20;const oc3=CW*0.20;const oc4=CW-oc1-oc2-oc3;
    y2=drawRow(p2,[
      {x:ML,         w:oc1,fill:C.laranja,text:'Origem',      fn:fontBold,cl:C.branco},
      {x:ML+oc1,     w:oc2,fill:C.laranja,text:'Propostas',   fn:fontBold,cl:C.branco,al:'c'},
      {x:ML+oc1+oc2, w:oc3,fill:C.laranja,text:'Vendas',      fn:fontBold,cl:C.branco,al:'c'},
      {x:ML+oc1+oc2+oc3,w:oc4,fill:C.laranja,text:'Conversão (%)',fn:fontBold,cl:C.branco,al:'c'},
    ],y2);
    Object.entries(data.secao3_orcamentos).forEach(([k,v],i)=>{
      if(y2<50) return;
      const fill=i%2===0?C.cinzaClaro:C.branco;
      y2=drawRow(p2,[
        {x:ML,         w:oc1,fill,text:k.charAt(0).toUpperCase()+k.slice(1)},
        {x:ML+oc1,     w:oc2,fill,text:String(v.propostas),al:'c'},
        {x:ML+oc1+oc2, w:oc3,fill,text:String(v.vendas),al:'c'},
        {x:ML+oc1+oc2+oc3,w:oc4,fill,text:`${v.taxa}%`,al:'c'},
      ],y2);
    });
  }

  // Segmentação por Tipo de Serviço
  if ((s4.porTipoServico||[]).length > 0) {
    y2-=20;
    drawRect(p2,ML,y2+2,CW,16,C.cinzaChumbo);
    drawText(p2,'SEGMENTAÇÃO POR TIPO DE SERVIÇO',ML+6,y2+7,8,fontBold,C.branco);
    y2-=16;
    const tc1=CW*0.40;const tc2=CW*0.20;const tc3=CW*0.20;const tc4=CW-tc1-tc2-tc3;
    y2=drawRow(p2,[
      {x:ML,             w:tc1,fill:C.laranja,text:'Tipo de Serviço', fn:fontBold,cl:C.branco},
      {x:ML+tc1,         w:tc2,fill:C.laranja,text:'Nº Vendas',       fn:fontBold,cl:C.branco,al:'c'},
      {x:ML+tc1+tc2,     w:tc3,fill:C.laranja,text:'Valor (R$)',      fn:fontBold,cl:C.branco,al:'r'},
      {x:ML+tc1+tc2+tc3, w:tc4,fill:C.laranja,text:'Percentual (%)',  fn:fontBold,cl:C.branco,al:'c'},
    ],y2);
    s4.porTipoServico.forEach((g,i)=>{
      if(y2<50) return;
      const fill=i%2===0?C.cinzaClaro:C.branco;
      y2=drawRow(p2,[
        {x:ML,             w:tc1,fill,text:(g.grupo||'—').substring(0,32)},
        {x:ML+tc1,         w:tc2,fill,text:String(g.numeroVendas),al:'c'},
        {x:ML+tc1+tc2,     w:tc3,fill,text:fmtBRL(g.totalVendido),al:'r'},
        {x:ML+tc1+tc2+tc3, w:tc4,fill,text:`${Number(g.percentual||0).toFixed(1)}%`,al:'c'},
      ],y2);
    });
  }

  drawFooter(p2);

  const pdfBytes=await pdfDoc.save();
  const blob=new Blob([pdfBytes],{type:'application/pdf'});
  const url=URL.createObjectURL(blob);
  const link=document.createElement('a');
  link.href=url; link.download='relatorio-vendas-servico.pdf';
  link.click(); URL.revokeObjectURL(url);
};

export default generatePdfRelatorioVendasServico;